import {Injectable, OnInit} from '@angular/core';
import { Subject } from 'rxjs';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Headers, Response } from '@angular/http';
import * as Raven from "raven-js";

@Injectable()
export class AuthService {

  private _token: string;
  private _cancelAuthCalls: boolean;
  private _authenticating: boolean;
  private _jwtHelper: JwtHelperService = new JwtHelperService();
  private _user: any;

  private isLoggedIn = false;
  private parsed_url;
  private requestId;
  private personId;
  private guestId;

  // Observable boolean sources
  private isLoggedInSource = new Subject<boolean>();

  // Observable string streams
  isLoggedIn$ = this.isLoggedInSource.asObservable();

  constructor(
    private _router: Router,
    private _http: Http
  ) {
    this._token = localStorage.getItem('externalToken');
    this.requestId = localStorage.getItem('requestId');
    this.personId = localStorage.getItem('personId');
    this.guestId = localStorage.getItem('guestId');
    this.parsed_url = window.location.pathname.split('/');
    localStorage.setItem('externalLocationTarget', window.location.pathname);
    if ( this.loggedIn() ) {
      // // accessing request page (if ids dont match, logout)
      // if (this.parsed_url.length === 6) {
      //   if (
      //     this.parsed_url[1] === 'request' &&
      //     this.requestId === this.parsed_url[2] &&
      //     this.personId === this.parsed_url[5]
      //   ) {
      //     this._router.navigateByUrl(localStorage.getItem('externalLocationTarget'));
      //   }
      //   else {
      //     this.logout();
      //   }
      // }
      // // accessing overview page (if ids dont match, logout)
      // else if ( this.parsed_url.length === 4) {
      //   if (
      //     this.parsed_url[1] === 'request' &&
      //     this.parsed_url[2] === 'overview' &&
      //     this.requestId === this.parsed_url[3]
      //   ) {
      //     this._router.navigateByUrl(localStorage.getItem('externalLocationTarget'));
      //   }
      //   else {
      //     this.logout();
      //   }
      // }
      // // accessing another link
      // else if(this.parsed_url[1] === 'login') {
      //   this.isLoggedIn = false;
      //   this._user = null;
      //   this._token = null;
      //   this._cancelAuthCalls = true;
      //   localStorage.removeItem('externalToken');
      //   localStorage.removeItem('requestId');
      //   localStorage.removeItem('personId');
      //   localStorage.removeItem('guestId');
      // }
      // // accessing tcp page
      // else if (this.parsed_url.length == 5 && this.parsed_url[4] === 'tcp') {
      //   this._router.navigateByUrl(localStorage.getItem('externalLocationTarget'));
      // }
      // else if (this.parsed_url[1] === 'upload-test' ) {
      //   this._router.navigate(['upload-test']).then(res => { console.log});
      // }
      // else {
      //   this.logout();
      // }
    }
    // TODO: This needs to be changed
    else if(this.parsed_url[1] === 'onboarding'){
      console.log("");
    }
    else if (this.parsed_url[1] !== 'cancelled' && this.parsed_url[1] !== 'login' && this.parsed_url.length !== 3 ) {
      this._router.navigate(['welcome']).then(res => { console.log});
    }
    else if (this.parsed_url[1] === 'cancelled' ) {
      this._router.navigate(['cancelled']).then(res => { console.log});
    }
  }


  loggedIn() {
    if (this._token === undefined || this._token === null || this._jwtHelper.isTokenExpired(this._token)) {
      return false;
    }
    else {
      return true;
    }
  }

  logout() {
    this.isLoggedIn = false;
    this._user = null;
    this._token = null;
    this._cancelAuthCalls = true;
    localStorage.removeItem('externalToken');
    localStorage.removeItem('requestId');
    localStorage.removeItem('personId');
    localStorage.removeItem('guestId');
    localStorage.removeItem('sentryToken');
    this._router.navigate(['logout']).then(res => { console.log});
  }

  logout2() {
    this.isLoggedIn = false;
    this._user = null;
    this._token = null;
    this._cancelAuthCalls = true;
    localStorage.removeItem('externalToken');
    localStorage.removeItem('sentryToken');
  }

  getRequestId() {
    return this.requestId;
  }

  getPersonId() {
    return this.personId;
  }

  getPersonRouterLink() {
    return '/request/' + this.requestId + '/person/edit/' + this.personId;
  }

  getRequestRouterLink() {
    return '/request/overview/' + this.requestId;
  }

  getLinkID() {
    const info = this._jwtHelper.decodeToken(this._token);
    return info['link_id'];
  }

  getLoginType(){
    const info = this._jwtHelper.decodeToken(this._token);
    if ('isVolunteer' in info && info['isVolunteer']){
      return 'Volunteer'
    }
    if ('isTCP' in info && info['isTCP']) {
      return 'TCP'
    }
    if ('isAuthorizedRep' in info && info['isAuthorizedRep']){
      return 'AuthorizedRep'
    }
    return 'person'; // need to return a non-empty string for IE headers
  }

  login(info) {
    this._token = info['token'];
    this.requestId = info['requestId'];
    this.personId = info['personId'];
    this.guestId = info['guestId'];
    localStorage.setItem('externalToken', this._token);
    localStorage.setItem('requestId', this.requestId);
    localStorage.setItem('personId', this.personId);
    localStorage.setItem('guestId', this.guestId);
    this.setupSentry(info, this._http);
    this._cancelAuthCalls = false;
    this.isLoggedIn = true;
    this.isLoggedInSource.next(true);
  }

  onboardingLogin(info){

    this._token = info['token'];   
    this.personId = info['personId'];
    this.requestId = info['requestId'];
    localStorage.setItem('externalToken', this._token);
    localStorage.setItem('personId', this.personId);
    localStorage.setItem('requestId', this.requestId);
    //this.setupSentry(info, this._http);
    this._cancelAuthCalls = false;

    this.isLoggedIn = true;
    this.isLoggedInSource.next(true);


  }

  authenticating() {
    return this._authenticating;
  }

  getCanCancelAuthCalls() {
    return this._cancelAuthCalls;
  }

  getName() {
    return this._user.displayName;
  }

  getToken() {
    return this._token;
  }

  getUser() {
    return this._user;
  }

  getGuestId() {
    return this.guestId;
  }

  getRoles() {
    return this._user.roles;
  }

  isSuperAdmin() {
    let isRole = false;
    for (let role of this._user.roles) {
      if(role['is_role'] && role['role'] === 'isSuperAdmin') {
        isRole = true;
      }
    }
    return isRole;
  }

  isAdmin() {
    let isRole = false;
    for (let role of this._user.roles) {
      if(role['is_role'] && role['role'] === 'isAdmin') {
        isRole = true;
      }
    }
    return isRole;
  }

  canBypassValidation() {
    return false;
  }

  canInvite() {
    const info = this._jwtHelper.decodeToken(this._token);
    return info['can_invite'];
  }


  setupSentry(info, http) {
    localStorage.setItem('sentryToken', info['sentry_token']);
    this._user = this._jwtHelper.decodeToken(info['token']).user;
    const sentry_dsns = {
      dev:
        "https://none@6cfjqk1s34.execute-api.us-west-2.amazonaws.com/dev",
      int:
        "https://none@6cfjqk1s34.execute-api.us-west-2.amazonaws.com/int",
      test:
        "https://none@6cfjqk1s34.execute-api.us-west-2.amazonaws.com/test",
      production:
        "https://none@6cfjqk1s34.execute-api.us-west-2.amazonaws.com/prod"
    };

    const dsn = this._jwtHelper.decodeToken(info['sentry_token']).env || "dev";

    Raven.config(sentry_dsns[dsn], {
        transport: function (options) {
            const headers = new Headers();
            headers.append("X-AWS-Sentry-Auth", info['sentry_token']);
            options.data['message'] = "-Frontend] " + options.data['message'];
            options.data['current_env'] = dsn;
            options.data['msg_header'] = "-Frontend] ";
            http.post(options.url, options.data, {headers: headers})
              .toPromise()
              .then(res => {
                if (res) {
                  console.log(res);
                }
              })
              .catch(err => {
                if (err) {
                  console.log(err);
                }
              });
        }
    }).install();

    // set the context so sentry logs have the user info
    Raven.setUserContext({
      email: this._user.email,
      first_name: this._user.first_name,
      last_name: this._user.last_name,
    });
  }
}


